export function mapMakeSeriesOperator(node, ctx) {
    const aggList = ctx.getChild(node, "AggregationList");
    const aggregations = [];
    if (aggList) {
        const items = ctx.getChildren(aggList, "AggregationItem");
        for (const item of items) {
            const identNode = ctx.getChild(item, "Identifier");
            const funcNode = ctx.getChild(item, "FunctionCall");
            if (funcNode) {
                aggregations.push({
                    type: "Aggregation",
                    alias: identNode ? ctx.slice(identNode) : undefined,
                    function: ctx.mapFunctionCall(funcNode),
                    start: item.from,
                    end: item.to,
                });
            }
        }
    }
    return {
        type: "MakeSeriesOperator",
        aggregations,
        on: {},
        step: {},
        start: node.from,
        end: node.to,
    };
}
